import axios from 'axios';
import numeral from '../utils/numeral';

const axiosInstance = axios.create({
    headers: {
        'Content-Type': 'application/json'
    }
});

export async function createCreditCardTransaction({ fields, country }) {
    const result = await  axiosInstance.post('/api/card/create', {
        ...fields,
        country
    });
    return result.data;
}

export async function paymentCreditCard(payment) {
    const result = await axiosInstance.post('/api/card/payment', {
        ...payment
    });
    return result.data;
}
